import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { AssetGroup } from './assetgroup.entity';
//#endregion

export const AssetGroupConfig = {
  name: "AssetGroup",
  annotations: [],
  fields: {
    name: {type: 'Edm.String'},
    description: {type: 'Edm.String'},
    value: {type: 'Edm.String'},
    sortValue: {type: 'Edm.Int32'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    assetGroupTreeAssigments: {type: 'entities.assets.AssetGroupTreeAssigment', collection: true, navigation: true},
    metaDataList: {type: 'entities.assets.AssetGroupMetaData', collection: true, navigation: true},
    assetGroups: {type: 'entities.assets.AssetGroup', collection: true, navigation: true},
    customerAssetGroups: {type: 'entities.customers.CustomerAssetGroup', collection: true, navigation: true},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<AssetGroup>;